<template>
  <div>
    <div
      class="mb-4 flex justify-between space-x-8"
      aria-label="Tabs"
    >
      <button
        v-for="tab in tabs"
        :key="tab"
        :class="[
          tab === modelValue
            ? 'border-primary text-primary'
            : 'border-transparent text-background-fg/50 hover:border-background-fg/70 hover:text-background-fg/70',
          'grow whitespace-nowrap border-b-2 px-1 py-2 text-sm font-semibold',
        ]"
        @click="emit('update:modelValue', tab)"
      >
        {{ tab }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string
  tabs: string[]
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void
}>()
</script>
